var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// filepath: /home/jules/dev/workflow-platform/package/ggoclientcomponent/components/list/VariableList.ts
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let VariableList = class VariableList extends LitElement {
    render() {
        return html `
      <variable-section
        .title=${msg('Org Params', { id: 'variable.title.orgParams', desc: 'Organization parameters section title' })}
        .label=${msg('Add global variable', { id: 'variable.action.addGlobal', desc: 'Add global variable button' })}
        .variables=${this.params}
      ></variable-section>
      <variable-section
        .title=${msg('Workflow Variables', { id: 'variable.title.workflowVariables', desc: 'Workflow variables section title' })}
        .label=${msg('Add workflow variable', { id: 'variable.action.addWorkflow', desc: 'Add workflow variable button' })}
        .variables=${this.workflow_variables}
      ></variable-section>
      <variable-section
        .title=${msg('Engines', { id: 'variable.title.engines', desc: 'Workflow engines section title' })}
        .label=${msg('Add workflow engine', { id: 'variable.action.addEngine', desc: 'Add workflow engine button' })}
        .variables=${this.engines}
      ></variable-section>
    `;
    }
};
VariableList.styles = css `
    :host {
      display: block;
      font-family: inherit;
    }

    .search-container {
      margin-bottom: 12px; /* Réduction de 25% */
    }
  `;
__decorate([
    property({ type: Object })
], VariableList.prototype, "workflow_variables", void 0);
__decorate([
    property({ type: Object })
], VariableList.prototype, "params", void 0);
__decorate([
    property({ type: Object })
], VariableList.prototype, "engines", void 0);
VariableList = __decorate([
    localized(),
    customElement('variable-list')
], VariableList);
export { VariableList };
//# sourceMappingURL=VariableList.js.map